import { parseISO } from "date-fns";
import { format, toZonedTime } from "date-fns-tz";

export const formatNumber = (num: number): string => {
  if (num === 0) {
    return "0";
  }
  const units = ["", "K", "M", "B", "T"];
  const k = 1000.0;
  const magnitude = Math.floor(Math.log(num) / Math.log(k));
  let formattedNumber = (num / k ** magnitude).toFixed(1);

  formattedNumber = Number.parseFloat(formattedNumber).toString();

  return `${formattedNumber}${units[magnitude]}`;
};

export const formattedDateToUTC = (date?: string | Date | null): string => {
  let parsedDate: Date;

  if (date === undefined || date === null) {
    parsedDate = new Date();
  } else if (typeof date === "string") {
    parsedDate = parseISO(date);
    if (Number.isNaN(parsedDate.getTime())) {
      throw new RangeError("Invalid date string");
    }
  } else if (date instanceof Date) {
    if (Number.isNaN(date.getTime())) {
      throw new RangeError("Invalid date object");
    }
    parsedDate = date;
  } else {
    throw new TypeError("Invalid input type");
  }

  const utcDate = toZonedTime(parsedDate, "UTC");

  return format(utcDate, "MMM dd, yyyy", {
    timeZone: "UTC",
  });
};
